"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOError = void 0;
class IOError extends Error {
    constructor(msg) {
        super(msg ? `IOError: ${msg}` : "IOError");
    }
}
exports.IOError = IOError;
//# sourceMappingURL=IOError.js.map